module.exports = __webpack_public_path__ + "static/img/lateral-esquerda.2216cb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lateral-esquerda.png
// module id = +Yys
// module chunks = 3